import { render } from "./BarcodeArchive.vue?vue&type=template&id=2c480a29"
import script from "./BarcodeArchive.vue?vue&type=script&lang=ts"
export * from "./BarcodeArchive.vue?vue&type=script&lang=ts"
script.render = render

export default script